export const SET_DATA_PERFORMANCE_TOOL_RESULT =
  "SET_DATA_PERFORMANCE_TOOL_RESULT";
export const SET_DATA_VULNERABILITY = "SET_DATA_VULNERABILITY";
export const SET_DATA_PERFORMANCE = "SET_DATA_PERFORMANCE";
export const SET_VULNERABILITY_APPLY = "SET_VULNERABILITY_APPLY";
export const SET_VULNERABILITY_LOADING = "SET_VULNERABILITY_LOADING";
export const SET_URL_EXPORT_VULNERABILITY = "SET_URL_EXPORT_VULNERABILITY";
